import React, { ReactElement } from 'react';
import FormatService from '../../services/format-service';
import useStylesPageError from './page-error.styles';

const PageError: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    isCentered,
    message,
    className,
    extraComponent,
  } = props;

  const { classes } = useStylesPageError();

  const centeredClassName: string | undefined = isCentered ? classes.pageErrorCentered : undefined;

  return (
    <div className={FormatService.formatClassNames(classes.pageError, centeredClassName, className)}>
      <div>
        {message}
      </div>
      {
        !!extraComponent && (
          <div className={classes.pageErrorExtraBlock}>
            {extraComponent}
          </div>
        )
      }
    </div>
  );
});

export default PageError;
